import blissCustomizeMetalData from "./bliss";
import gourdCustomizeMetalData from "./gourd";
import seasonsCustomizeMetalData from "./seasons";
import plentyCustomizeMetalData from "./plenty";
import heartCustomizeMetalData from "./heart.js";
import ingotCustomizeMetalData from "./ingot.js";
import squareCustomizeMetalData from "./square.js";
import circleCustomizeMetalData from "./circle.js";
import sacredObjectCustomizeMetalData from "./sacred_object.js";

/**
 * @description 客製化金牌資料
 * @typedef {Object} CustomizeMetalData - 客製化金牌資料
 * @property {string} shape - 形狀 (例如: "如意")
 * @property {string} name - 金牌名稱 (例如: "如意五福雙獅")
 * @property {string} code - 金牌代碼 (例如: "A")
 * @property {string} imagePath - 金牌圖片路徑
 * @property {number[]} accessory - 可選配件陣列，包含以下選項
 *                                  1：無 / 2：壓克力架 / 3：禮盒 / 4：禮盒+壓克力架 / 5：已含，附壓克力架美術包裝紙盒
 * @property {string[]} way - 可選刻字方式陣列，包含以下選項
 *                            A：精緻平裝純金金牌 / B：立體浮雕純金金牌 / C：立體浮雕鐳射紅字純金金牌 / D：週歲鎖片 / E：立體浮雕純金獎牌 / F：手工精雕雙面扇 / G：手工紋飾單面扇 / H：傳統金牌雷雕字體
 * @property {string} engravingContentType - 刻字內容類型，包含以下選項，影響 textSetting 設定
 *                                          default：預設刻字內容 / sacredObject：法器金牌 / commemorative_license_plate：紀念車牌 / commemorative_doorplate：紀念門牌 / commemorative_medal：紀念獎牌
 * @property {Object} textSetting - 文字設定物件
 * // 當 engravingContentType 為 default 時，textSetting 結構如下：
 * @property {Object} textSetting.templeName - 廟宇名稱文字設定
 * @property {number} textSetting.templeName.lineLimit - 廟宇名稱行數限制
 * @property {number} textSetting.templeName.textLimit - 廟宇名稱每行文字數限制
 * @property {number} textSetting.templeName.maxFontsize - 廟宇名稱最大字體大小
 * @property {Object} textSetting.godName - 神明名稱文字設定
 * @property {number} textSetting.godName.lineLimit - 神明名稱行數限制
 * @property {number} textSetting.godName.textLimit - 神明名稱每行文字數限制
 * @property {number} textSetting.godName.maxFontsize - 神明名稱最大字體大小
 * @property {Object} textSetting.gift - 祈福文字設定
 * @property {number} textSetting.gift.lineLimit - 祈福文字行數限制
 * @property {number} textSetting.gift.textLimit - 祈福文字每行文字數限制
 * @property {number} textSetting.gift.maxFontsize - 祈福文字最大字體大小
 */

export const customizeMetalData = [
  // 如意金牌
  ...blissCustomizeMetalData,
  // 葫蘆金牌
  ...gourdCustomizeMetalData,
  // 春秋金牌
  ...seasonsCustomizeMetalData,
  // 大福金牌
  ...plentyCustomizeMetalData,
  // 桃心金牌
  ...heartCustomizeMetalData,
  // 元寶金牌
  ...ingotCustomizeMetalData,
  // 方框金牌
  ...squareCustomizeMetalData,
  // 圓框金牌
  ...circleCustomizeMetalData,
  // 法器金牌
  ...sacredObjectCustomizeMetalData,
];
